import { css, forBrands, useTheme, Theme, Brands } from '@core-ui/react-stitch';
import { Size, LARGE, XLARGE } from '@core-ui/breakpoint-provider';

const brRedesignPriceMarkdownStyles = css`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline;
  margin-right: 0.3rem;
  text-decoration: line-through;
`;

const brRedesignMultiLinePriceStyles = ({ size, abbrBrand }: { size: Size, abbrBrand: Brands }) => (
  ![XLARGE].includes(size) && (abbrBrand === Brands.BananaRepublic)
    ? ''
    : css`display: inline;`
);

const brRedesignPriceLineItemStyles = ({ size, abbrBrand }: { size: Size, abbrBrand: Brands }) => (
  ![XLARGE].includes(size) && (abbrBrand === Brands.BananaRepublic)
    ? ''
    : css`margin-left: 0.3rem;`
);

const brRedesignTruncatedPriceStyles = (
  { theme, size, abbrBrand }: { theme: Theme, size: Size, abbrBrand: Brands }
) => (
  ![XLARGE].includes(size) && (abbrBrand === Brands.BananaRepublic)
    ? ''
    : css`
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: ${theme.color.wh};
      `
);

const brRedesignFontStyles = ({ theme, size }: { theme: Theme, size: Size }) => {
  const sizeDependentFontStyles = {
    'large': '0.9375rem',
    'x-large': '1.0625rem',
    'default': '0.8125rem'
  };

  return css`
    font-weight: 350;
    color: ${theme.color.wh};
    font-size: ${sizeDependentFontStyles[[XLARGE, LARGE].includes(size) ? size : 'default']};
  `;
};

const brRedesignPaddingStyles = ({ size }: { size: Size }) => {
  const sizeDependentPadding = {
    'large': '0.25rem',
    'x-large': '0.5rem',
    'default': '0.1875rem'
  };

  return css`
    padding-top: ${sizeDependentPadding[[LARGE, XLARGE].includes(size) ? size : 'default']};
  `;
};

const brRedesignStyleOverrides = ({ size, abbrBrand }: { size: Size, abbrBrand: Brands }) => {
  const theme = useTheme();
  const commonOverrides = css`
    span,
    span.product-price__highlight--brff {
      ${brRedesignFontStyles({ theme, size })}
    }
    span.product-price__no-strike {
      ${brRedesignFontStyles({ theme, size })}
      text-decoration: line-through;
    }
    div.product-price__markdown {
      ${brRedesignPriceMarkdownStyles}
      ${brRedesignFontStyles({ theme, size })}
    }
    div.product-price__highlight--brff {
      ${brRedesignMultiLinePriceStyles({ size, abbrBrand })}
      ${brRedesignFontStyles({ theme, size })}
    }
    div.product-price--line-item  {
      ${brRedesignMultiLinePriceStyles({ size, abbrBrand })}
      ${brRedesignPriceLineItemStyles({ size, abbrBrand })}
      ${brRedesignFontStyles({ theme, size })}
    }
    div {
      ${brRedesignTruncatedPriceStyles({ theme, size, abbrBrand })}
    }
    ${brRedesignPaddingStyles({ size })}
  `;

  return forBrands(theme, {
    br: commonOverrides,
    brfs: commonOverrides,
  });
};

export default brRedesignStyleOverrides;
